define('page/intro', [
    'utils/common'
], function (common) {
    'use strict';

    // 定制小程序服务 form
    var nameEL = document.querySelector('#introName')
    var phoneEl = document.querySelector('#introPhone')
    var needEl = document.querySelector('#introNeed')
    var btnEl = document.querySelector('#introSubmit')

    if (nameEL && phoneEl && btnEl && needEl) {
        btnEl.addEventListener('click', function () {
            common.submitForm([nameEL, phoneEl, needEl])
        })
    }
});  
